export default {"src":"https://static.snobase.com/_next/static/media/snobase-hero-vector.4e8dc633.svg","height":1186,"width":1327,"blurWidth":0,"blurHeight":0};